import React, { useEffect, useRef, useState } from "react";
import { ExternalLink, Link2 } from "lucide-react";

import "./LinkContentViewer.css";

export default function LinkContentViewer({ content, progress, onTrack }) {
    const waitingReturnRef = useRef(false);
    const [hasOpened, setHasOpened] = useState(Boolean(progress?.progressPayload?.opened));

    useEffect(() => {
        const handleReturn = () => {
            if (!waitingReturnRef.current) return;
            waitingReturnRef.current = false;
            onTrack?.({
                completionPercent: Math.max(Number(progress?.progressPercent || 0), 10),
                progressPayload: {
                    opened: true,
                    returnedAt: new Date().toISOString(),
                },
                immediate: true,
            });
        };

        const handleVisibilityChange = () => {
            if (!document.hidden) {
                handleReturn();
            }
        };

        window.addEventListener("focus", handleReturn);
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            window.removeEventListener("focus", handleReturn);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [content?.id, onTrack, progress?.progressPercent]);

    const handleOpen = () => {
        waitingReturnRef.current = true;
        setHasOpened(true);
        onTrack?.({
            completionPercent: Math.max(Number(progress?.progressPercent || 0), 10),
            progressPayload: {
                opened: true,
                openedAt: new Date().toISOString(),
            },
            immediate: true,
        });
        window.open(content.externalUrl, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="cr-card lcv-card">
            <div className="lcv-header">
                <Link2 size={32} className="lcv-icon" />
                <div>
                    <h3>{content.title || "Lien externe"}</h3>
                    <p>{content.description || "Ce contenu s'ouvre dans un nouvel onglet de votre navigateur."}</p>
                </div>
            </div>
            
            <div className="lcv-actions">
                <button className="cr-btn cr-btn--primary" onClick={handleOpen} disabled={!content.externalUrl}>
                    {hasOpened ? "Rouvrir le lien" : "Ouvrir le lien"}
                    <ExternalLink size={16} />
                </button>
            </div>
        </div>
    );
}
